import React from 'react'
import RegistrationLayout from './../../_global/RegistrationLayout'
import CreateAccount from './CreateAccount'

interface RegistrationComponentProps {
  history: any
  queryParamsWithSource?: boolean
  setIsFirm: (isFirm: boolean) => void
}

const Registration = ({ history, queryParamsWithSource, setIsFirm }: RegistrationComponentProps) => {
  return (
    <RegistrationLayout isByob={false}>
      <CreateAccount history={history} isFurloughReferral={!!queryParamsWithSource} setIsFirm={setIsFirm} />
    </RegistrationLayout>
  )
}

export default Registration
